import React, { useEffect, useState } from "react";
import { QuestMap } from "./QuestMap";
import { redirectToEditorProject } from "../../features/redirect";
import { store } from "../../core/state";
import { QUEST_VIEW_NAME } from "../../core/constants";
import { getAppCfg } from "../../core/app-cfg";
import { getCurrentQuestAchievement } from "../../features/stats";

export const QuestsContainer = () => {
  const [questViewData] = store.useState(QUEST_VIEW_NAME);    
  const [achievedQuestItem, setAchievedQuestItem] = useState(0);
  
  useEffect(() => {
    let current = getCurrentQuestAchievement(getAppCfg().quest);
    if (current < 0) {
      current = 0;
    }
    setAchievedQuestItem(current);
  }, []);

  function waypointClicked(item) {
    redirectToEditorProject(item.projectCode);
  }
  
  if (!questViewData.data) return null;
  return <>
    <h1>{questViewData.data.name}</h1>
    <QuestMap items={questViewData.data.path} 
              achievedWaypointIndex={achievedQuestItem} 
              waypointClicked={waypointClicked} />
  </>
}